//increment the version so I can 'wipe' it

//TODO 20241210 - get these from elsewhere and reference specific project/assembly
import {sliceInitial as initialSystem, SystemSlice} from "./slices/systemSlice";
import { app_version, app_version_prefix, cache_prefix } from "./constants";

import {localconsole} from "../App";
import { ProjectBuilder } from "./objects/projectBuilder";

//this function is used as a handler in the store subscribe() method, it's attached in the app and called when a state change happens
export const onStateChange = (state: any) => {
    try {
        let diagrams = {
            system: state.system,
            assembly: state.assembly,
            //svg: state.svg,
            ui: state.ui,
        };
        let stateString = JSON.stringify(diagrams);
      localStorage.setItem(app_version, stateString);

    } catch(err) {
        //check if localStorage is full
        console.log(err);
        console.log("localStorage is full, remove some diagrams")
    }
};

//
export const cacheDiagram = (hash: string, diagram: string) => {
  let cachedName = `${cache_prefix}_${hash}`;
  if (hash === "" || diagram === "") {
  return
  }
  localStorage.setItem(cachedName, diagram)
  countdownToExpiry(hash)
}
//
export const expireCachedDiagramNow = (hash: string | null) => {
  if (hash === null) {
  return
  }
  let cachedExpiryName = `${cache_prefix}e_${hash}`;
  let expire_limit = Date.now() - 15 * 24 * 60 * 60 * 1000
  localStorage.setItem(cachedExpiryName, (Date.now() - expire_limit).toString());
}
//
export const getCachedDiagram = (hash: string) => {
  let cachedName = `${cache_prefix}_${hash}`;
  let cachedSVG = localStorage.getItem(cachedName);
  return cachedSVG
}

export const removeFromCache = (hash: string | null) => {
  let cachedName = `${cache_prefix}_${hash}`;
  let cachedExpiryName = `${cache_prefix}e_${hash}`;
  localStorage.removeItem(cachedName)
  localStorage.removeItem(cachedExpiryName)
}

export const countdownToExpiry = (hash: string) => {
  let cachedExpiryName = `${cache_prefix}e_${hash}`;
  localStorage.setItem(cachedExpiryName, Date.now().toString());
}
//prefix is something like ${app_version}_csvge so I can seperate the cache keys to remove them
export const evictExpiredCache = () => {
  //TODO - centralise, I have just copied pattern from systemSlice as LLM doing crazy unreadable stuff
  //let cachedExpiryName = "${app_version}_csvge_${hash}";
  for (const key in localStorage) {
    if (!key || !key.startsWith(cache_prefix)) continue;
    if (key.startsWith(`${cache_prefix}e_`)) {
      let expiry = localStorage.getItem(key)
      if (!expiry) continue;

      const expiry_time = parseInt(expiry, 10)


      let expire_limit = Date.now() - 9 * 24 * 60 * 60 * 1000
      if (isNaN(expiry_time) || (expiry_time < expire_limit) ) {

        //just add e to prefix for expiry
        let expired_item_hash = key.slice().replace(`${cache_prefix}e_`, "")
        removeFromCache(expired_item_hash)

      }
      }
  }

}

//loadState from localStorage using current tree version
export const loadState = () => {
    localconsole("ENTER: loadState")
    let ret = undefined;
    try {
        let stateString = localStorage.getItem(app_version);
        if (stateString !== null) {
            let savedState = JSON.parse(stateString);
            //fill in any missing state

            {
                type systemKey = keyof SystemSlice
                let keys: systemKey[] = Object.keys(initialSystem) as systemKey[]
                keys.forEach((k: systemKey) => {
                    if (savedState.system[k] === undefined) {
                        savedState.system[k] = initialSystem[k]
                    }
                })
                for (let p of savedState.system.projects) {
                    if (!p.version) {
                        p.version = 1
                    }
                }
            }
            ret = savedState;
        }

        //tidy up the old state
        for (const key in localStorage) {
            if (key == app_version) {
                continue
            } else if (key.startsWith(app_version_prefix)) {
                localStorage.removeItem(key)
            }
        }
    } catch (err) {
        console.log(err);
    }
    return ret;
};
